module.exports = __webpack_public_path__ + "img/layout-sidebar.e5749719.svg";